var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    stroke: "#E4E7EB",
    d: "M13 .5C19.904.5 25.5 6.096 25.5 13S19.904 25.5 13 25.5.5 19.904.5 13 6.096.5 13 .5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    stroke: "#fff",
    strokeWidth: 0.4,
    d: "M7.501 13a1.9 1.9 0 0 0 .54 1.385c.364.374.868.596 1.4.615a1.94 1.94 0 0 0 .719-.146 1.87 1.87 0 0 0 .604-.401l3.88 2.283a1.897 1.897 0 0 0 .515 1.649c.364.375.867.596 1.4.615a2.052 2.052 0 0 0 1.4-.615 1.9 1.9 0 0 0 .54-1.385 1.896 1.896 0 0 0-.54-1.385 2.052 2.052 0 0 0-1.4-.615 1.927 1.927 0 0 0-.719.145 1.87 1.87 0 0 0-.604.401l-3.878-2.282c.014-.087.022-.176.025-.264a1.98 1.98 0 0 0-.025-.265l3.875-2.281a1.9 1.9 0 0 0 1.322.546 2.053 2.053 0 0 0 1.402-.614c.364-.374.56-.873.542-1.386a1.896 1.896 0 0 0-.54-1.385 2.052 2.052 0 0 0-1.4-.615 2.052 2.052 0 0 0-1.4.615 1.897 1.897 0 0 0-.517 1.65l-3.875 2.282a1.864 1.864 0 0 0-.604-.401A1.925 1.925 0 0 0 9.445 11a2.052 2.052 0 0 0-1.402.614 1.898 1.898 0 0 0-.542 1.385Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.260b9dca34e6a8dcbff4a3db6bb4d69a.svg";
export { ForwardRef as ReactComponent };